module.exports = __webpack_public_path__ + "static/media/growth.1f375484.svg";